import api from '../api';
const jsRoutes = require('routes.js.erb');

const getAnalytics = function({ commit }, itemId) {
  return api.get(jsRoutes.api_v5_stats_path(itemId)).then(function(response){
    commit('setStats', response.data.data.stats);
  })
};

const updateStats = function({ commit }, { itemId, params }) {
  return api.put(jsRoutes.update_stats_api_v5_item_path(itemId), params);
};

export { getAnalytics, updateStats };
